import { useStore } from '@bluheadless/ui-logic/src/providers/store'
import NextHead from 'next/head'

const Website = () => {
	const store = useStore()

	return (
		<>
			<NextHead>
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: JSON.stringify({
							'@context': 'https://schema.org',
							'@type': 'WebSite',
							url: store.uri,
						}),
					}}
				/>
			</NextHead>
		</>
	)
}

export default Website
